var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("validation-provider", {
          attrs: { rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ errors }) {
                return [
                  _c("custom-radio", {
                    staticClass: "custom-radio",
                    attrs: {
                      "custom-error-msg": "El campo es requerido.",
                      disabled: _vm.isReadOnly,
                      error: !!errors[0],
                      name: "tableType",
                      options: _vm.tableOptions
                    },
                    model: {
                      value: _vm.tableType,
                      callback: function($$v) {
                        _vm.tableType = $$v
                      },
                      expression: "tableType"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    !_vm.isReadOnly
      ? _c(
          "div",
          { staticClass: "my-3" },
          [
            _c(
              "div",
              { staticClass: "col d-flex align-items-end" },
              [
                _c("custom-drop-down", {
                  staticClass: "w-40",
                  attrs: {
                    clearable: false,
                    fieldkey: "id",
                    fieldname: "name",
                    "is-html": "",
                    label: "Prueba/Muestra - Módulo:",
                    options: _vm.modules,
                    placeholder: "Seleccione"
                  },
                  model: {
                    value: _vm.moduleSelected,
                    callback: function($$v) {
                      _vm.moduleSelected = $$v
                    },
                    expression: "moduleSelected"
                  }
                }),
                _c(
                  "action-button",
                  {
                    staticClass: "ml-2",
                    attrs: {
                      disabled: !_vm.moduleSelected,
                      i: "fas fa-file-plus",
                      variant: "success"
                    },
                    on: {
                      click: function($event) {
                        return _vm.addModule()
                      }
                    }
                  },
                  [_vm._v(" Añadir ")]
                )
              ],
              1
            ),
            _c("validation-provider", {
              ref: "modules",
              attrs: {
                name: "modules",
                rules: _vm.model.areas.length > 0 ? "" : "required"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        errors[0]
                          ? _c("error", {
                              staticClass: "m-3",
                              attrs: {
                                message: "Añada al menos un módulo",
                                variant: "no-border"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                649972377
              )
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "m-3" },
      _vm._l(_vm.model.areas, function(item) {
        return _c(
          "div",
          { key: item.area.id },
          [
            _c("answer", {
              attrs: { "is-read-only": _vm.isReadOnly, value: item },
              on: {
                input: function($event) {
                  return _vm.onAnswer(item, $event)
                },
                remove: function($event) {
                  return _vm.removeArea($event)
                }
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "m-3" },
      [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v(
            " Interpretación de las pruebas SAM administradas de acuerdo con los resultados obtenidos: "
          )
        ]),
        _vm.isReadOnly
          ? _c("p", [_vm._v(_vm._s(_vm._f("empty")(_vm.model.comment)))])
          : _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-text-area", {
                        attrs: {
                          "count-classes": [
                            "d-block",
                            "small-counter",
                            "text-right"
                          ],
                          "custom-error-msg": "El campo es requerido.",
                          error: errors[0],
                          maxlength: 5000,
                          "show-char-count": ""
                        },
                        model: {
                          value: _vm.model.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "comment", $$v)
                          },
                          expression: "model.comment"
                        }
                      })
                    ]
                  }
                }
              ])
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }